import { serverApi } from '../api';

// Rutas que se ejecutan SIN sesión (kioskos y pantallas de sala)
const RUTAS_SIN_SESION = [
    '/',
    '/Ingreso',
    '/cola',
    '/cola2',
    '/callscreen',
    '/callscreen-v2',
    '/pantalla',
    '/crear',
    '/crear2',
    '/superadmin',
];

// Paneles de SuperAdmin / Vendedor con sesión propia (saToken / vendedorToken)
const RUTAS_SIN_SESION_PREFIJO = [
    '/superadmin/dashboard',
    '/vendedor/dashboard',
];

export const rutaRequiereSesion = (pathname) => {
    if (!pathname) return false;
    if (RUTAS_SIN_SESION.includes(pathname)) return false;
    return !RUTAS_SIN_SESION_PREFIJO.some((ruta) => pathname.startsWith(ruta));
};

// Verifica contra el servidor que el token siga siendo válido (y lo renueva)
export const verificarSesionActiva = async () => {
    const token = localStorage.getItem('token');
    if (!token) return false;

    try {
        const resp = await serverApi.get('/auth/renew');
        if (resp.data && resp.data.ok) {
            localStorage.setItem('token', resp.data.token || token);
            return true;
        }
        return true;
    } catch (error) {
        // Solo se cierra sesión cuando el servidor rechaza el token (401/403).
        // En errores de red no se puede confirmar: se conserva la sesión.
        const status = error.response?.status;
        if (status === 401 || status === 403) {
            return false;
        }
        console.error('No se pudo verificar la sesión', error);
        return true;
    }
};